import grapesjs from 'drapcode-builder';
import loadComponents from './components';
import loadBlocks from './blocks';
import { componentRef } from './consts';

export default grapesjs.plugins.add('gjs-otp-authenticator', (editor, opts) => {
  let options = opts || {};

  let defaults = {
    pfx: 'otp-authenticator',
    blocks: [componentRef],
    defaultStyle: true,
    labelTable: 'OTP Authenticator',
    labelOTPAuthenticatorCategory: 'Forms',
  };

  for (let name in defaults) {
    if (!(name in options)) options[name] = defaults[name];
  }
  loadComponents(editor, options);
  loadBlocks(editor, options);
});
